import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createKanbanPageAction } from '../actions/createKanbanPage.action';
import { createKanbanCategoryAction } from '../actions/createKanbanCategories.action';
import { CreateFlowTaskInput, createTodoTaskAction } from "../actions/createTodoTask.action";
import { useAppDispatch } from '../../../redux/hooks/redux';
import { fetchBenefits } from '../../../permissions/benefits/redux/benefits.thunks';

const DefaultTask: CreateFlowTaskInput = {
  kanbanCategoryUid: "",
  name: "This is your first task!",
  description: "Welcome to Flow Do!",
  status: "TODO",
  priority: "LOW",
}

export const useCreateKanbanPage = () => {
  const queryClient = useQueryClient();
  const dispatch = useAppDispatch();

  return useMutation({
    mutationFn: async (name: string) => {
      const newPage = await createKanbanPageAction(name);
      try {
        const newCategory = await createKanbanCategoryAction("General", newPage.uid);
        await createTodoTaskAction({
          kanbanCategoryUid: newCategory.uid,
          name: DefaultTask.name,
          description: DefaultTask.description,
          status: DefaultTask.status,
          priority: DefaultTask.priority,
        });
      } catch (error) {
        console.error("Failed to create default category or task", error);
        // We still return the page even if category creation fails, 
        // though ideally we might want to handle this more gracefully
      }
      return newPage;
    },
    onSuccess: () => {
      dispatch(fetchBenefits());
      // Invalidate and refetch kanban pages and categories
      queryClient.invalidateQueries({
        queryKey: ['kanban-pages'],
      });
      queryClient.invalidateQueries({
        queryKey: ['kanban-categories'],
      });
      // Invalidate kanban-data to refetch tasks as well
      queryClient.invalidateQueries({
        queryKey: ['todo-tasks'],
      });
    },
  });
};

